export default "__VITE_ASSET__DmfDgfnp__"